import { ChildMachineConfig } from "@checkout/types";
import { ActionTypes } from "./actions";
import { GuardTypes } from "./guards";
import { ChFARExerciseState } from "./types";

export const getMachine = (config: ChildMachineConfig) => ({
  initial: ChFARExerciseState.route,
  states: {
    [ChFARExerciseState.route]: {
      always: [
        {
          target: ChFARExerciseState.addDiscount,
          cond: GuardTypes.hasChfarId,
        },
        {
          target: config.nextState,
        },
      ],
    },
    [ChFARExerciseState.addDiscount]: {
      always: [
        {
          actions: ActionTypes.setDiscount,
          target: config.nextState,
        },
      ],
    },
  },
});
